import web from "@/core/middlewares/web";
let instruction = () => import(/* webpackChunkName: "plans" */ '@/views/instruction/Index');
export default [
        {
            path: "/instruction",
            name: "instruction.index",
            component: instruction,
            meta: {
                middleware: web,
                permissions: ['instruction:viewAny'],
                title: "آموزش"
            }
        },
]
